/*
 *
 * Error reducer
 *
 */
import produce from 'immer';
import { get } from 'lodash';
import { LOCATION_CHANGE } from 'redux-first-history';

import {
  DEFAULT_ACTION,
  SHOW_TOAST,
  HIDE_TOAST,
  RESET_ERROR_TITLE,
  RESET_TWO_FACTOR_VERIFICATION,
} from './constants';

import { AUTHENTICATION_MODALS } from '../../utils/constants';

export const initialState = {
  data: null,
  isOpen: false,
  autoCloseTimer: 8000,
  errorTitle: '',
  isTwoFactorAuthenticated: false,
  // Last pathname seen via LOCATION_CHANGE, so we can tell a real navigation
  // (clears the toast) from a same-page search/hash update (keeps it).
  lastPathname: null,
};

/* eslint-disable default-case, no-param-reassign */
const closeToast = (draft) => {
  if (draft.data?.className) {
    draft.data = { className: draft.data?.className };
  } else {
    draft.data = null;
  }
  draft.isOpen = false;
};

const toastReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SHOW_TOAST: {
        // checking if authentication is required
        const title = get(action.data, 'errorMeta.title', '');
        const data = get(action.data, 'errorMeta.data', {});
        const className = get(action.data, 'errorMeta.className', '');

        if (title && AUTHENTICATION_MODALS.includes(title)) {
          draft.errorTitle = title;
          draft.errorData = data;
          draft.className = className;
        } else draft.isOpen = true;

        draft.data = action.data;
        break;
      }
      case HIDE_TOAST: {
        closeToast(draft);
        break;
      }
      case RESET_ERROR_TITLE: {
        draft.errorTitle = '';
        break;
      }
      case RESET_TWO_FACTOR_VERIFICATION: {
        draft.isTwoFactorAuthenticated = action.data;
        break;
      }
      case LOCATION_CHANGE: {
        // A toast from the page just left reads as confusing (or wrong) on the page just
        // entered. A search/hash-only update on the same page is not a navigation, so it
        // keeps the toast on screen.
        const nextPathname = get(action, 'payload.location.pathname', null);
        if (
          draft.isOpen &&
          draft.lastPathname &&
          nextPathname &&
          nextPathname !== draft.lastPathname
        ) {
          closeToast(draft);
        }
        if (nextPathname && draft.lastPathname !== nextPathname) {
          draft.lastPathname = nextPathname;
        }
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default toastReducer;
